
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { PositionEnum } from '../enums'

import { UiDatepicker } from './keen-ui'
import { EpbButton } from './shared/epb-button'
import TimePicker from './time-picker.component.vue'

export default defineComponent({
  name: 'DatePicker',
  components: {
    EpbButton,
    TimePicker,
    UiDatepicker,
  },
  props: {
    value: Date,
    includeTime: Boolean,
    displayFrom: {
      type: String as PropType<PositionEnum>, // PositionEnum.TOP, PositionEnum.LEFT
      default: PositionEnum.TOP,
    },
    disabled: Boolean,
    messages: {
      type: Object,
      required: true,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseClass: 'epb-date-picker',
    }
  },
  methods: {
    onDateChange(date: Date): void {
      const hours = (!!this.value && this.value.getHours()) || 0
      const minutes = (!!this.value && this.value.getMinutes()) || 0
      this.$emit(
        'input',
        new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0, 0),
      )
    },
    clear(): void {
      this.$emit('input', undefined)
    },
  },
})
